import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5acf5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white pt-[60px] building-second-wrap page-building-list" }
const _hoisted_2 = { class: "flex items-center justify-center building-second-nav" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content w-[100%] box-border pt-[60px]" }
const _hoisted_5 = { class: "new-list relative z-10" }
const _hoisted_6 = { class: "px-[60px] w-[100%]" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-1 whitespace-nowrap text-ellipsis overflow-hidden pr-[14px]" }
const _hoisted_9 = { class: "whitespace-nowrap flex-shrink-0 text-[#999] text-[14px]" }
const _hoisted_10 = { class: "flex justify-center pt-[99px] pb-[73px] building-second-pagination" }

import { onMounted, reactive, ref } from "vue";
import { IPagination } from "@/interface/index";
import useNavigation from "@/hooks/useNavigation";
import useGetNewsNavList from "@/hooks/useGetNewsNavList";
import { getPage } from "@/http/api";
export interface IListItem {
  id: string;
  title: string;
  banner?: string;
  content?: string;
  digest?: string;
  children?: Array<IListItem>;
}
interface IItem {
  title: string;
  id: string;
  creatTime?: string;
  children?: Array<IItem>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SecondBuild',
  setup(__props) {

const dataList = ref<Array<IItem>>([]);
const leafList = ref<Array<IItem>>([]);
const activeIndex = ref(0);
const { push, router } = useNavigation();
function changeActive(index) {
  activeIndex.value = index;
  currentChange(1);
}
const pagination = reactive<IPagination>({
  total: 0,
  pageSize: 15,
  pageNum: 1,
});

function currentChange(pageNum = 1) {
  pagination.pageNum = pageNum;
  getPageFunc(leafList.value[activeIndex.value].id);
}

function goDetail({ id }) {
  push({
    path: "/partyBuilding/detail",
    query: {
      id,
    },
  });
}

const { getNewsInfo } = useGetNewsNavList<{ type: string }>(
  "/partyBuilding",
  pullData,
  [{ type: "1" }]
);
function pullData(res) {
  leafList.value = res.data[0].data.leftList || [];
  const { id } = router.currentRoute.value.query;
  if (id) {
    activeIndex.value = leafList.value.findIndex((v) => v.id == id);
  }
  getPageFunc(id || leafList.value[activeIndex.value].id);
}
function getPageFunc(menuId) {
  getPage({
    pageNum: pagination.pageNum,
    pageSize: pagination.pageSize,
    menuId,
  }).then((res) => {
    pagination.total = res.total || 0;
    dataList.value = res.rows || [];
  });
}
onMounted(() => {
  getNewsInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leafList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["list-item", activeIndex.value === index ? 'active' : '']),
          onClick: ($event: any) => (changeActive(index))
        }, _toDisplayString(item.title), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (demo) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "doc flex cursor-pointer text-[#666] text-[16px] leading-[20px] pb-[16px] hover:text-[var(--el-color-primary)]",
              key: demo.id,
              onClick: ($event: any) => (goDetail(demo))
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(demo.title), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(demo.creatTime), 1)
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_pagination, {
            "prev-text": "上一页",
            "next-text": "下一页",
            background: "",
            layout: "prev, pager, next",
            "current-page": pagination.pageNum,
            total: pagination.total,
            "page-size": pagination.pageSize,
            onCurrentChange: currentChange
          }, null, 8, ["current-page", "total", "page-size"])
        ])
      ])
    ])
  ]))
}
}

})